(ns common.schema.entities.kpi-cycle
  (:require [common.schema.schema-utils :as su]
            [common.currencies :as currencies]
            [common.kpis :as kpis]))

(def schema
  (vec (concat (su/single-ref-field :kpi-cycle/kpi-category "Category" [:entity.type/kpi-category] {:authorization su/access-user-ssg})
               (su/keyword-multi-field :kpi-cycle/kpis "KPI's" kpis/kpi-options {:authorization su/access-user-ssg})
               (su/text-simple-field :kpi-cycle/name "Name" {:authorization su/access-user-ssg})
               (su/text-edn-field :kpi-cycle/ordering "Order" {:authorization su/access-user-ssg})
               (su/keyword-multi-field :kpi-cycle/questions "Questions" kpis/question-options {:authorization su/access-user-ssg})
               (su/integer-field :kpi-cycle/target-month "Target month" {:authorization su/access-user-ssg})
               (su/integer-field :kpi-cycle/target-year "Target year" {:authorization su/access-user-ssg})
               (su/text-edn-field :kpi-cycle/user-guidances "User guidance" {:authorization su/access-user-ssg}))))
